import RideForm from "Components/Forms/RideForm";
import MapPageLayout from "Layout/Other/MapPageLayout";

function EditRidePage() {
    return (<MapPageLayout>
        <RideForm />
    </MapPageLayout>);
}

export default EditRidePage;